import { render, staticRenderFns } from "./OrganizationBase.vue?vue&type=template&id=caf51b16&scoped=true"
import script from "./OrganizationBase.vue?vue&type=script&lang=js"
export * from "./OrganizationBase.vue?vue&type=script&lang=js"
import style0 from "./OrganizationBase.vue?vue&type=style&index=0&id=caf51b16&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caf51b16",
  null
  
)

export default component.exports